import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Tippy from '@tippyjs/react';
import { CommentControls } from './CommentControl';
import { CommentItem } from './types';
import { useCommentActions } from './commentActions';

interface CommentHeaderProps {
  isActiveComment: boolean;
  comment: CommentItem;
  isUpdating?: boolean;
  setMenuOpen: (open: boolean) => void;
  menuOpen: boolean;
  actionHandler: (action: string, e: React.MouseEvent) => void;
  readOnly?: boolean;
}

export const CommentHeader = ({ isActiveComment, comment, setMenuOpen, menuOpen, actionHandler, readOnly = false }: CommentHeaderProps) => {
  const { t } = useTranslation('common');
  const { hasAny: hasActions } = useCommentActions(comment);

  const author = comment?.user ? `${comment?.user.firstName} ${comment?.user.lastName}` : '';
  return (
    <div className="comment--header">
      <div className="inner">
        <div className={`${isActiveComment ? 'active' : ''} comment--header`}>
          <div className="comment--header--icon user--circle">
            <div style={{ lineHeight: '2rem' }}>{initials(author)}</div>
          </div>
        </div>

        <div className="comment--header--author">
          <div className="comment--header--author--name">{author}</div>

          <div className="comment--header--author--date">{moment(comment?.createdAt).format('YYYY-MM-DD HH:mm')}</div>
        </div>
      </div>

      <div className="comment--controls--wrapper">
        {!readOnly && !comment?.closedAt && comment?.publishedAt && (
          <button type="button" className="not-a-button comment-icon" onClick={(e) => actionHandler('close', e)}>
            <i className="fa-regular fa-check" />
          </button>
        )}
        {!readOnly && !comment?.publishedAt && !comment.closedAt && (
          <button type="button" className="not-a-button comment-icon" onClick={(e) => actionHandler('edit', e)}>
            <i className="fa-regular fa-pen" />
          </button>
        )}
        {comment?.closedAt && (
          <div className="comment--archived">
            <div>
              <i className="fa-regular fa-box-archive"></i>
            </div>
            {t('closed')}
          </div>
        )}
        {!readOnly && hasActions && (
          <Tippy
            content={<CommentControls comment={comment} actionHandler={actionHandler} setMenuOpen={setMenuOpen} />}
            onClickOutside={() => setMenuOpen(false)}
            placement="bottom-end"
            interactive={true}
            appendTo="parent"
            visible={menuOpen}
          >
            <button
              type="button"
              className="not-a-button comment-icon"
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen(!menuOpen);
              }}
            >
              <i className="fa-regular fa-ellipsis-v" />
            </button>
          </Tippy>
        )}
      </div>
    </div>
  );
};

const initials = (name: string) =>
  name
    .split(' ')
    .map((w) => w.substr(0, 1))
    .map((c) => c.toUpperCase())
    .join('');
